<template>
  <div>
    <div
      class="fixed inset-x-0 bottom-0 z-20 transition-opacity md:hidden"
      :class="[!isFloating && 'opacity-0', `${paddingClasses}`]"
    >
      <slot></slot>
    </div>
    <span
      ref="button"
      class="transition-opacity"
      :class="{ 'opacity-0': isFloating }"
    >
      <slot></slot>
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  paddingClasses: {
    type: String as PropType<string>,
    required: false,
    default: 'px-11 py-5',
  },
  scrollRootSelector: {
    type: String as PropType<string>,
    default: null,
  },
})

const button = ref<Element>()
const isFloating = ref(false)
const observer = ref<IntersectionObserver>()
const lastTriggerPosition = ref(0)

onMounted(async () => {
  /**
   * We want to show the floating button on page load and until user scrolls
   * below it. Also want to show it again after user scrolls back above it.
   */
  observer.value = new IntersectionObserver(
    (entries) => {
      const scrollTop =
        props.scrollRootSelector &&
        document.querySelector(props.scrollRootSelector)
          ? (document.querySelector(props.scrollRootSelector)?.scrollTop ??
            lastTriggerPosition.value)
          : window.scrollY

      if (
        !entries[0]?.isIntersecting &&
        scrollTop <= lastTriggerPosition.value
      ) {
        isFloating.value = true
      } else {
        isFloating.value = false
      }
      lastTriggerPosition.value = scrollTop
    },
    {
      root: props.scrollRootSelector
        ? document.querySelector(props.scrollRootSelector)
        : null,
      rootMargin: '-50px 0px -50px 0px ',
    },
  )
  await nextTick()
  if (button.value) {
    observer.value.observe(button.value)
  }
})

onBeforeUnmount(() => {
  observer?.value?.disconnect()
})
</script>
